import React from "react";
import grassBg from "../../../Assets/grassBg.png";

const HeroBanner = () => {
  return (
    <div className="bg-white p-12">
      <div className="bg-[#0b3d2c] pt-4">
        <section
          className="relative w-full h-32 flex items-center justify-center bg-cover bg-center rounded-lg "
          style={{
            backgroundImage: `url(${grassBg})`,
          }}
        >
          <div className=" w-full h-full rounded-lg flex items-center justify-center">
            <h2 className="text-white text-[13px] md:text-3xl font-bold text-center px-4 w-[70%]">
              HARNESS THE POWER OF AI TO CARE FOR YOUR TREES LIKE NEVER BEFORE.
            </h2>
          </div>
        </section>
      </div>
    </div>
  );
};

export default HeroBanner;
